// extracted by mini-css-extract-plugin
module.exports = {"inlineMath":"InlineMath-module--inlineMath--1uTlb"};